
import { Badge } from "@/components/ui/badge";

interface LeadStatusBadgeProps {
  status: string;
}

export function LeadStatusBadge({ status }: LeadStatusBadgeProps) {
  const getStatusInfo = (status: string) => {
    switch (status) {
      case "to_visit":
        return {
          label: "To Visit",
          className: "bg-blue-100 text-blue-800 hover:bg-blue-100",
        };
      case "visit_scheduled":
        return {
          label: "Visit Scheduled",
          className: "bg-purple-100 text-purple-800 hover:bg-purple-100",
        };
      case "visited":
        return {
          label: "Visited",
          className: "bg-indigo-100 text-indigo-800 hover:bg-indigo-100",
        };
      case "shortlisted":
        return {
          label: "Shortlisted",
          className: "bg-pink-100 text-pink-800 hover:bg-pink-100",
        };
      case "application_submitted":
        return {
          label: "Application Submitted",
          className: "bg-cyan-100 text-cyan-800 hover:bg-cyan-100",
        };
      case "waitlist":
        return {
          label: "On Waitlist",
          className: "bg-amber-100 text-amber-800 hover:bg-amber-100",
        };
      case "declined":
        return {
          label: "Declined",
          className: "bg-red-100 text-red-800 hover:bg-red-100",
        };
      case "contacted":
        return {
          label: "Contacted",
          className: "bg-blue-100 text-blue-800 hover:bg-blue-100",
        };
      case "scheduled":
        return {
          label: "Visit Scheduled",
          className: "bg-green-100 text-green-800 hover:bg-green-100",
        };
      default:
        return {
          label: "Interested",
          className: "bg-gray-100 text-gray-800 hover:bg-gray-100",
        };
    }
  };

  const statusInfo = getStatusInfo(status);

  return (
    <Badge className={statusInfo.className}>
      {statusInfo.label}
    </Badge>
  );
}
